// Salay Print Theme JS
document.addEventListener('DOMContentLoaded', function() {

  // ============================================
  // STICKY HEADER
  // ============================================
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // ============================================
  // MOBILE MENU TOGGLE
  // ============================================
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('active');
      this.textContent = nav.classList.contains('active') ? '✕' : '☰';
    });
  }

  // ============================================
  // ADD TO CART ANIMATION
  // ============================================
  document.querySelectorAll('.product-card__cta, .btn--primary').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (this.classList.contains('product-card__cta')) {
        const originalText = this.textContent;
        this.textContent = 'Added ✓';
        this.style.background = '#28a745';
        setTimeout(() => {
          this.textContent = originalText;
          this.style.background = '';
        }, 1500);
      }
    });
  });

  // ============================================
  // SCROLL-TRIGGERED JUMP UP ANIMATIONS
  // ============================================

  // Add scroll-animate class to all elements that should animate
  const animateSelectors = [
    '.product-card',
    '.category-card',
    '.step-card',
    '.testimonial-card',
    '.section-header',
    '.promo-banner__title',
    '.promo-banner__text',
    '.promo-banner .btn',
    '.newsletter__title',
    '.newsletter__text',
    '.newsletter__form',
    '.hero__content',
    '.hero__image'
  ];

  // Apply staggered delays to grid children
  function applyStaggeredDelays(parentSelector, childSelector) {
    document.querySelectorAll(parentSelector).forEach(function(parent) {
      const children = parent.querySelectorAll(childSelector);
      children.forEach(function(child, index) {
        child.classList.add('scroll-animate');
        child.classList.add('delay-' + (index + 1));
      });
    });
  }

  // Apply to product grid
  applyStaggeredDelays('.products-grid', '.product-card');
  // Apply to categories grid
  applyStaggeredDelays('.categories-grid', '.category-card');
  // Apply to steps grid
  applyStaggeredDelays('.steps-grid', '.step-card');
  // Apply to testimonials grid
  applyStaggeredDelays('.testimonials-grid', '.testimonial-card');

  // Apply basic scroll-animate to section headers and other elements
  document.querySelectorAll('.section-header, .promo-banner__title, .promo-banner__text, .promo-banner .btn, .newsletter__title, .newsletter__text, .newsletter__form').forEach(function(el) {
    if (!el.classList.contains('scroll-animate')) {
      el.classList.add('scroll-animate');
    }
  });

  // Hero gets special treatment - animate from left/right
  const heroContent = document.querySelector('.hero__content');
  const heroImage = document.querySelector('.hero__image');
  if (heroContent) heroContent.classList.add('scroll-animate-left');
  if (heroImage) heroImage.classList.add('scroll-animate-right');

  // ============================================
  // INTERSECTION OBSERVER - Triggers animations
  // ============================================
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
  };

  const scrollObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        scrollObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all animated elements
  document.querySelectorAll('.scroll-animate, .scroll-animate-scale, .scroll-animate-left, .scroll-animate-right').forEach(function(el) {
    scrollObserver.observe(el);
  });

  // ============================================
  // TRIGGER HERO ANIMATION ON LOAD (immediate)
  // ============================================
  setTimeout(function() {
    if (heroContent) heroContent.classList.add('is-visible');
    setTimeout(function() {
      if (heroImage) heroImage.classList.add('is-visible');
    }, 200);
  }, 300);

});
